var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCryptooAntsPremiumIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_250_574)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3399 33.1377L16.5111 31.0234C13.5903 30.313 11.0566 29.8409 8.67912 32.2183C5.73826 35.1577 7.14368 38.4824 7.98567 41.8535L12.7469 60.8967C13.9835 65.8417 14.2265 70.7637 20.9239 70.7637H65.0768C71.7298 70.7637 72.0021 65.9064 73.2153 61.0497C73.6367 59.3641 73.9847 57.9738 74.4055 56.2884C75.2214 53.0287 75.9891 49.9563 76.7866 46.7678C77.3852 44.3703 79.0897 38.5706 79.0897 36.4005C79.0897 33.2275 76.2866 30.4508 72.7561 30.4508C71.5607 30.4508 65.8835 32.0234 64.0402 32.4845C63.1344 32.7105 61.9413 33.1176 61.0452 33.1377L57.1615 28.1909C56.4603 27.3334 55.9016 26.623 55.2035 25.7345C54.5256 24.8708 53.9374 24.097 53.2239 23.2983C51.9841 21.9083 48.2244 16.7541 47.2276 16.0482C44.7217 14.273 41.7963 14.1367 39.2951 15.994C38.4004 16.6581 26.8196 30.929 25.3399 33.1377Z",
    fill: "#2488FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1963 83.0485H66.8042C73.3947 83.0485 73.3947 74.6022 66.8042 74.6022H19.1963C13.9569 74.6022 13.0932 79.6882 15.6858 81.9512C16.5294 82.6867 17.6872 83.0485 19.1963 83.0485Z",
    fill: "#2488FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.8167 5.11134C37.8167 11.9249 48.184 11.9249 48.184 5.11134C48.184 -1.70378 37.8167 -1.70378 37.8167 5.11134Z",
    fill: "#2488FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000366211 22.0042C0.000366211 24.4544 0.84238 26.4139 3.14085 27.3086C7.36649 28.9508 11.4837 25.0024 9.96363 20.6778C8.08929 15.3439 0.000366211 17.0171 0.000366211 22.0042Z",
    fill: "#2488FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.0006 22.9639V22.0043C86.0006 19.7754 83.6219 17.3964 81.3945 17.3964C78.944 17.3964 76.9832 18.2384 76.0883 20.5385C74.4462 24.7625 78.3959 28.8797 82.7194 27.3597C84.2267 26.8304 86.0006 25.0086 86.0006 22.9639Z",
    fill: "#2488FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_250_574"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 86,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryptooAntsPremiumIcon);
export default __webpack_public_path__ + "static/media/CryptooAntsPremiumIcon.7ed3329abfd549fb2465bbde94b3d285.svg";
export { ForwardRef as ReactComponent };